// KCBox's KC table auto-generate: pure helpers (no React / webpack aliases),
// so they run under node --test.

// The variety generateKCTable looks up: the field's, when the crop records
// have it under the field's crop type, else 'general'. A field with no crop
// type yet (a new block's pre-season) or one missing from the records gets
// 'general'; generateKCTable then rejects and the auto-generate link stays
// hidden.
const autoGenerateVarietyOf = (cropRecords, cropType, cropVariety) =>
  cropRecords?.[String(cropType || '').toLowerCase()]?.[
    String(cropVariety || '').toLowerCase()
  ]
    ? cropVariety
    : 'general';

module.exports = { autoGenerateVarietyOf };
